import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { FaroErrorBoundary, withFaroProfiler } from '@grafana/faro-react';
import { MutationCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import PartialSuccessNotice from './Components/PartialSuccessNotice';
import { showToast, ToastViewport } from './Components/Toast';

import ContextProvider from './services/context';
import Router from './routes';
import { ThemeModeProvider } from './themeMode';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
  mutationCache: new MutationCache({
    onSuccess: (data, variables, context, mutation) => {
      if (mutation?.options?.meta?.successToast === false) return;
      const responseMessage = typeof data?.message === 'string' ? data.message : undefined;

      showToast({
        message: mutation?.options?.meta?.successMessage || responseMessage || 'Success!',
        severity: 'success',
      });
    },
  }),
});

function App() {
  return (
    <BrowserRouter>
      <FaroErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <ThemeModeProvider>
            <ContextProvider>
              <Router />
              <ToastViewport />
              <PartialSuccessNotice />
            </ContextProvider>
          </ThemeModeProvider>
        </QueryClientProvider>
      </FaroErrorBoundary>
    </BrowserRouter>
  );
}

export default withFaroProfiler(App);
